import { CONTACT_NETWORK_PROFILES, CONTACT_NETWORK_TYPE, CONTROLLER_CONSTANTS, LEAD_TYPES } from '@/utils/constants';
import {
    capitalizeFilter,
    currencyFilter,
    monthYearFilter,
    networkContactFilter,
    cardTypeFilter,
    dateFilter,
    numberFilter,
    snakeCaseFilter,
    cnpjFilter
} from '@/utils/filters';
export default {
    name: 'ContactDetails',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: 'auto'
        },
        selectedContact: {
            type: Object,
            default: () => {
                return {};
            }
        },
        subscription: {
            type: Object,
            default: () => {
                return {};
            }
        },
        isSupplier: {
            type: Boolean,
            default: false
        },
        contactAdquired: {
            type: Boolean,
            default: false
        },
        contactVisualized: {
            type: Boolean,
            default: false
        },
        subscriptionEngelinkCash: {
            type: Number,
            default: 0
        },
        subscriptionBonusCash: {
            type: Number,
            default: 0
        },
        hasSubscription: {
            type: Boolean,
            default: false
        },
        disableButton: {
            type: Boolean,
            default: false
        },
        contactFilters: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            censoredField: '*******',
            CONTACT_NETWORK_PROFILES: CONTACT_NETWORK_PROFILES,
            CONTACT_NETWORK_TYPE: CONTACT_NETWORK_TYPE,
            CONTROLLER_CONSTANTS: CONTROLLER_CONSTANTS,
            LEAD_TYPES: LEAD_TYPES
        };
    },
    methods: {
        capitalizeFilter,
        currencyFilter,
        monthYearFilter,
        networkContactFilter,
        cardTypeFilter,
        dateFilter,
        numberFilter,
        snakeCaseFilter,
        cnpjFilter,
        openProCreditPaymentModal() {
            // abrir os modais com essa confirmação
            // @confirmation-positive="adquireSingleContact(COLOCAR O TIPO)"
            this.$emit('openProCreditPaymentModal');
        },
        openMixedPaymentModal() {
            this.$emit('openMixedPaymentModal');
        },
        openQualifiedCreditPaymentModal() {
            // abrir os modais com essa confirmação
            // @confirmation-positive="adquireSingleContact(COLOCAR O TIPO)"
            this.$emit('openQualifiedCreditPaymentModal');
        },
        openBonusPaymentModal() {
            // abrir os modais com essa confirmação
            // @confirmation-positive="adquireSingleContact(COLOCAR O TIPO)"
            this.$emit('openBonusPaymentModal');
        },
        openEngelinkCashPaymentModal() {
            // abrir os modais com essa confirmação
            // @confirmation-positive="adquireSingleContact(COLOCAR O TIPO)"
            this.$emit('openEngelinkCashPaymentModal');
        },
        adquireSingleContact(leadsTypes) {
            this.$emit('adquireSingleContact', leadsTypes);
        }
    },
    computed: {
        questionsAnswersAnswerOnly() {
            return this.selectedContact.questionsAnswers && this.selectedContact.questionsAnswers.length
                ? this.selectedContact.questionsAnswers.filter(data => data.answer)
                : [];
        }
    }
};
